import script from "./SupervisaoOrientacao.vue?vue&type=script&setup=true&lang=js"
export * from "./SupervisaoOrientacao.vue?vue&type=script&setup=true&lang=js"

import "./SupervisaoOrientacao.vue?vue&type=style&index=0&id=318e2495&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-318e2495"]])

export default __exports__